@if (teasers?.length || promotions?.length) {
    <ms-slideshow
        [auto]="true"
        [delay]="delay"
        [circular]="true"
        [pageindicators]="false"
        [mode]="slideMode"
        [realtotalslidecount]="totalCount()"
        [navigationMode]="navigationMode"
        [arrowPosition]="arrowLeftRightValue"
        [showProgressBar]="true"
        [overlayArea]="overlayArea"
        (slideChanged)="slideChanged($event)"
        (navigation)="track($event)">
        @for (promotion of promotions; track promotion.id; let position = $index) {
            <ms-slide [ngStyle]="{ width: maxSlideWidth ? '768px' : '100%' }">
                <ms-crm-promotion-banner [promotion]="promotion" [listIndex]="position" [isDynamicSize]="true" />
            </ms-slide>
        }
        @for (teaser of teasers; track teaser.title; let i = $index) {
            <ms-slide class="teaser" [ngStyle]="{ width: maxSlideWidth ? '768px' : '100%' }">
                @if (teaser.visibleTeaser) {
                    <img
                        #slide
                        fill
                        ngSrcset="480w, 640w, 768w"
                        sizes="(min-width: 960px) 768px, 100vw"
                        class="teaser-image"
                        [ngSrc]="teaser.imageUrl"
                        [priority]="i + promotions.length === 0" />
                }
                @if (isCurrentSlide(i + promotions.length)) {
                    <a [href]="teaser.href" [attr.target]="teaser.target" (click)="teaserClick($event, teaser, i)">
                        <div
                            class="teaser-content"
                            [class.with-odds]="!teaser.isPromotionalTeaser && teaser.displayOdds"
                            [class.no-gradient]="!teaser.title && !teaser.subtitle"
                            [ngClass]="{
                                'expanded-info': teaser.extract,
                                'gradient-alignment-left': teaser.textAlignment === 'Left',
                                'gradient-alignment-right': teaser.textAlignment === 'Right',
                            }">
                            <div class="teaser-text" [ngClass]="getTeaserAlignment(teaser)">
                                <div class="title text-white" [ngStyle]="{ visibility: teaser.title ? 'visible' : 'hidden' }">{{ teaser.title }}</div>
                                <div class="subtitle text-white" [ngStyle]="{ visibility: teaser.subtitle ? 'visible' : 'hidden' }">
                                    {{ teaser.subtitle }}
                                </div>

                                @if (!teaser.isPromotionalTeaser && teaser.displayOdds) {
                                    <div class="odds">
                                        @for (option of teaser.options; track option) {
                                            <span class="odds-item">{{ option }}</span>
                                        }
                                    </div>
                                }
                                @if (teaser.buttonText) {
                                    <a
                                        class="btn-teaser"
                                        ds-button
                                        kind="primary"
                                        variant="filled"
                                        size="large"
                                        [href]="teaser.href"
                                        [innerHTML]="teaser.buttonText | msTrust: 'html'"
                                        (click)="track()"></a>
                                }
                            </div>
                        </div>
                    </a>
                }
                @if (teaser.jackPot && teaser.jackpotBanner) {
                    <div class="teaser-content banner">
                        <ms-banner-jackpot class="teaser-text" [listIndex]="i + promotions.length" [model]="teaser.jackpotBanner" />
                    </div>
                }

                @if (teaser.info) {
                    <div class="teaser-info" [ngClass]="{ 'info-position': teaser.termsAndConditions && !teaser.extract }">
                        <vn-icon
                            class="teaser-icon"
                            size="16"
                            [name]="teaser.extract ? 'theme-close-i' : 'theme-info'"
                            (click)="infoClick($event, teaser)" />
                        @if (teaser.extract) {
                            <div class="info-message" [innerHTML]="teaser.info | msTrust: 'html'"></div>
                        }
                    </div>
                }
                @if (teaser.termsAndConditions) {
                    <div class="terms-conditions-container">
                        <span class="terms-conditions">{{ teaser.termsAndConditions }}</span>
                    </div>
                }
            </ms-slide>
        }
    </ms-slideshow>
}
